class ActiveRecipientSubscriptionViewModel {
    constructor({sub, tgt, shouldRemove, subMessages}) {
        this._sub = sub;
        this._tgt = tgt;
        this._tgtName = tgt.displayName;
        this._tgtSortAs = tgt.sortAs;
        this._shouldRemove = shouldRemove;
        this._subMessages = subMessages;
    }

    get sub() {
        return this._sub;
    }

    get tgt() {
        return this._tgt;
    }

    get tgtName() {
        return this._tgtName;
    }

    get tgtSort() {
        return this._tgtSortAs;
    }

    get shouldRemove() {
        return this._shouldRemove;
    }

    set shouldRemove(updatedVal) {
        this._shouldRemove = updatedVal;
    }

    get subMessages() {
        return this._subMessages;
    }
}

export default ActiveRecipientSubscriptionViewModel;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/ActiveRecipientSubscriptionViewModel.js
// module id = Bb77
// module chunks = 1